package com.trevorwiebe.timesheet.calendar.presentation.uiHelper

import kotlinx.datetime.LocalDate

data class DayUi(
    val date: LocalDate,
    val selectedForTimeOff: Boolean,
    var employeesOff: List<TimeOffRequestUi> = emptyList(),
) {
    val toggleTimeOff: DayUi
        get() = copy(selectedForTimeOff = !selectedForTimeOff)
}